import { server } from '../engine/server'
import { modal } from '../utilities/modal'

var Payable = Class.create({
  	initialize: function() {
        this.server = server;
	},
	sendVendorVerificationCode: function(phoneNum, callback) {
		var url = "vendor/login/";
        const params = {
            phone: phoneNum
        }
		var data = this.server.getData(url, params, true, "POST");
		data
		.done(function(response) {
            if (callback) {
                callback(response);
            }
		})
		.fail(function(e) {
			if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
		});
	},
    verifyVerificationCode: function(verificationCode, callback) {
		var url = "vendor/login/verify"
        const params = {
            code: verificationCode
        }
		var data = this.server.getData(url, params, true, "POST");
		data
		.done(function(response) {
            if (callback) {
                callback(response);
            }
		})
		.fail(function(e) {
			if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
		});
	},
    updateVendor: function(vendorId, vendorDetail, callback) {
        var self = this;
        var url = "vendor/" + vendorId;
        var params = vendorDetail;
        var data = self.server.getData(url, params, true, "PUT");
        data
        .done(function(response){
            if (callback) {
                callback(response);
            }
        })
        .fail(function(e){
            if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
        });
    },
    createVendor: function(vendorDetail, callback) {
        var self = this;
        var url = "vendor/new";
        var params = vendorDetail;
        var data = self.server.getData(url, params, true, "POST");
        data
        .done(function(response){
            if (callback) {
                callback(response);
            }
        })
        .fail(function(e){
            if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
        });
    },
    getVendor: function(vendorId, callback) {
        var self = this;
        var url = "vendor/" + vendorId; //TODO: Change to correct API link
        var data = self.server.getData(url, null, true, "GET");
        data
        .done(function(response){
            if (callback) {
                callback(response);
            }
        })
        .fail(function(e){
            if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
        });
    },
    deleteVendor: function(vendorId, callback) {
        var self = this;
        var url = "vendor/" + vendorId;
        var data = self.server.getData(url, null, true, "DELETE");
        data
        .done(function(response){
            if (callback) {
                callback(response);
            }
        })
        .fail(function(e){
            if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
        });
    },
    getVendorBill: function(vendorId, callback) {
        var self = this;
        var url = "vendor/bill/" + vendorId; 
        var data = self.server.getData(url, null, true, "GET");
        data
        .done(function(response){
            if (callback) {
                callback(response);
            }
        })
        .fail(function(e){
            modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
            if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
        });
    },
    createVendorBill: function(vendorBill, callback) {
        var self = this;
        var url = "vendor/bill/new";
        var params = vendorBill;
        var data = self.server.getData(url, params, true, "POST");
        data
        .done(function(response){
            if (callback) {
                callback(response);
            }
        })
        .fail(function(e){
            modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
            if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
        });
    },
    updateVendorBill: function(billId, vendorBill, callback) {
        var self = this;
        var url = "vendor/bill/" + billId;
        var params = vendorBill;
        var data = self.server.getData(url, params, true, "PUT");
        data
        .done(function(response){
            if (callback) {
                callback(response);
            }
        })
        .fail(function(e){
            if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
        });
    },
    deleteVendorBill: function(billId, callback) {
        var self = this;
        var url = "vendor/bill/" + billId;
        var data = self.server.getData(url, null, true, "DELETE");
        data
        .done(function(response){
            if (callback) {
                callback(response);
            }
        })
        .fail(function(e){
            if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
        });
    },
    payBill: function(billId, bank, callback) {
        var url = "vendor/bill/pay";
		var params = {
			billId: billId,
            bank_identifier: bank
        };
		var data = server.getData(url, params, true, "POST");
		data
		.done(function(response){
			if(response.status === 'ERROR') {
				modal.showInfo('Error! ' + JSON.parse(response.message.httpBody).error.message, 'danger', 'top', 'center');
			} else if(response.status == 'ERROR_INTERNAL') {
				modal.showInfo('Error! ' + response.message[0], 'danger', 'top', 'center');
			}else {
                if(callback) {
                    callback(response);
                }
			}
		})
		.fail(function(e){
			if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
		});
	},
});

export let payable = new Payable();



// WEBPACK FOOTER //
// app/core/controllers/Payable.js